import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  id: PropTypes.string.isRequired,
};

const CartIcon = ({ color = '#0D84FE', size = '21', id, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <path
        d="M15.043 6.743h4.436c.51 0 .927.417.927.926l-.028.25-2.353 8.586a1.861 1.861 0 0 1-1.787 1.353H4.196a1.842 1.842 0 0 1-1.778-1.353L.065 7.92a.78.78 0 0 1-.037-.25c0-.51.417-.926.927-.926H5.39L9.448.676a.905.905 0 0 1 .769-.398.92.92 0 0 1 .769.389l4.057 6.076zm-7.605 0h5.558l-2.78-4.076-2.778 4.076zm2.779 7.41a1.858 1.858 0 0 0 1.852-1.853 1.858 1.858 0 0 0-1.852-1.852A1.858 1.858 0 0 0 8.364 12.3c0 1.02.834 1.853 1.853 1.853z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use href={`#${id}-a`} />
      </mask>
      <path
        fill={color}
        mask={`url(#${id}-b)`}
        d="M-1.67 19.556h23.774V-1.42H-1.67z"
      />
    </g>
  </svg>
);

CartIcon.propTypes = propTypes;

export default CartIcon;
